import client from './client'
import store from '@/store'
import _ from 'lodash'
const { getBaseLoginAppURL } = require('./helpers/baseurl')

function ApiException (code, body, data) {
  this.code = code
  this.body = body
  this.data = data
  this.name = 'ApiException'
}

ApiException.prototype.toString = function () {
  return this.name + ': "' + this.body + '" (' + this.code + ')'
}

function parseResponse (response) {
  if (!response.data.success) {
    const userId = _.get(store.state, ['user', 'id'], null)
    if (response.data.errorCode === 4 && !userId) {
      window.location = getBaseLoginAppURL()
    }

    throw new ApiException(response.data.errorCode, response.data.error, response.data.data || null)
  }

  return response.data.data
}

export default {
  async getSettings () {
    return client.get(`/settings`).then(resp => {
      return resp.data.settings.dpURL
    })
  },
  async getInitialData () {
    return client.get(`/get-initial-data`).then((response) => {
      return parseResponse(response)
    })
  },
  async logout () {
    return client.post(`/logout`).then((response) => {
      return parseResponse(response)
    })
  },
  async getCases (skip, limit, filters, sortBy, order) {
    return client.get(`/cases/get`, {
      params: {
        skip: skip,
        limit: limit,
        sortBy: sortBy,
        order: order,
        filters: filters
      }
    }).then((response) => {
      return parseResponse(response)
    })
  },
  async getCaseReport (caseId, noHeader) {
    return client.get(`/cases/get-report`, {
      params: {
        caseId: caseId,
        noHeader: noHeader
      },
      responseType: 'arraybuffer',
      headers: {
        'Accept': 'application/pdf'
      }
    }).then((response) => {
      return response.data
    })
  },
  async createCase (caseData) {
    return client.post(`/cases/create`, caseData).then((response) => {
      return parseResponse(response)
    })
  },
  async updateCaseCreationOrder (caseData) {
    return client.post(`/cases/creation-orders/update`, caseData).then((response) => {
      return parseResponse(response)
    })
  },
  async cancelCaseCreationOrder (orderId) {
    return client.post(`/cases/creation-orders/cancel`, {
      id: orderId
    }).then((response) => {
      return parseResponse(response)
    })
  },
  async declineCaseCreationOrder (orderId, reason) {
    return client.post(`/cases/creation-orders/decline`, {
      id: orderId,
      reason: reason
    }).then((response) => {
      return parseResponse(response)
    })
  },
  async getCaseCreationOrders (skip, limit, filters) {
    return client.get(`/cases/creation-orders/get-list`, {
      params: {
        skip: skip,
        limit: limit,
        filters: filters
      }
    }).then((response) => {
      return parseResponse(response)
    })
  },
  async getCaseCreationOrder (orderId) {
    return client.get(`/cases/creation-orders/get`, {
      params: {
        id: orderId
      }
    }).then((response) => {
      return parseResponse(response)
    })
  },
  async getCaseCreationOrderBlank (orderId) {
    return client.get(`/cases/creation-orders/blank`, {
      params: {
        id: orderId
      },
      responseType: 'arraybuffer',
      headers: {
        'Accept': 'application/pdf'
      }
    }).then((response) => {
      const bytes = new Uint8Array(response.data || [])
      const isPdf = bytes.length >= 4 && bytes[0] === 0x25 && bytes[1] === 0x50 && bytes[2] === 0x44 && bytes[3] === 0x46
      if (!isPdf) {
        let parsed = null
        try {
          parsed = JSON.parse(new TextDecoder('utf-8').decode(response.data))
        } catch (e) {
          parsed = null
        }
        throw new ApiException(_.get(parsed, 'errorCode', 0), _.get(parsed, 'error', null), _.get(parsed, 'data', null))
      }
      return response.data
    })
  },
  async getCaseCreationOrderByMaterialCode (clientId, code) {
    return client.get(`/cases/creation-orders/get-by-material`, {
      params: {
        clientId: clientId,
        code: code
      }
    }).then((response) => {
      return parseResponse(response)
    })
  },
  async checkMaterialExists (code, caseId) {
    return client.get(`/cases/check-material-exists`, {
      params: {
        code: code,
        caseId: caseId
      }
    }).then((response) => {
      return parseResponse(response)
    })
  },

}
